module.exports = __webpack_public_path__ + "img/401.floor_link.41fef85f.svg";